import {
  get
} from '../axios'

class Approve {
  async getPageList(param) {
    const res = await get('/Approve/GetApprovePage', param)
    return res
  }
  async getApproveCount(param) {
    const res = await get('/Approve/GetApproveCount', param)
    return res
  }
}
export default new Approve()